module.exports = __webpack_public_path__ + "img/electronic_pending_zone.71e7c17a.svg";